import * as React from 'react'
import { styled } from 'next-yak'

import { t } from '@owl-nest/localize'
import * as plume from '@ulule/owl-kit-components/next'

import * as projectModel from '../../../../models/project'

type ProjectNotFinancedPropTypes = {
  project: projectModel.Project
}

export function ProjectNotFinanced({
  project,
}: ProjectNotFinancedPropTypes): React.ReactElement<ProjectNotFinancedPropTypes> {
  return (
    <ProjectNotFinancedContainer>
      <InformationContainer>
        <plume.styles.heading.XXS asDesktop="S">
          <plume.illustrations.twoToned.HeartWithConfetti size={60} noBackground inverted />
          {t('Thanks for believing in this project!')}
        </plume.styles.heading.XXS>

        <plume.styles.copy.M.light>
          {t('Despite your support, this project did not reach its goal. Your contribution has been fully refunded.')}
        </plume.styles.copy.M.light>
      </InformationContainer>

      <plume.styles.button.Button
        size="small"
        kind="secondary"
        as="a"
        href={`/discussions/compose/${project.owner.id}`}
      >
        {t('Message the  project creator')}
      </plume.styles.button.Button>
    </ProjectNotFinancedContainer>
  )
}

const ProjectNotFinancedContainer = styled.div`
  box-sizing: border-box;
  display: block;
  margin: 0 auto;
  max-width: 840px;
  padding: 20px;
  text-align: center;
  width: 100%;

  ${plume.styles.button.Button} {
    flex: none;
    flex-grow: 1;
    width: 100%;
  }

  // NOT SCREEN !
  @media not screen and ${plume.BREAKPOINTS.LAPTOP} {
    ${plume.illustrations.Illustration} {
      margin-bottom: 5px;
    }
  }

  @media screen and ${plume.BREAKPOINTS.LAPTOP} {
    align-content: center;
    align-items: center;
    display: flex;
    padding: 25px 0;
    text-align: left;

    ${plume.styles.button.Button} {
      width: auto;
    }
  }
`

const InformationContainer = styled.div`
  box-sizing: border-box;
  padding: 0 20px;
  width: 100%;

  ${plume.styles.heading.XXS} {
    display: block;
  }

  ${plume.styles.copy.M.light} {
    margin-bottom: 10px;
  }

  // NOT SCREEN !
  @media not screen and ${plume.BREAKPOINTS.LAPTOP} {
    ${plume.styles.heading.XXS} {
      align-items: center;
      display: flex;
      flex-direction: column;
      justify-content: center;
      margin-bottom: 0px;
    }
  }

  @media screen and ${plume.BREAKPOINTS.LAPTOP} {
    padding: 0;

    ${plume.styles.heading.XXS} {
      margin-bottom: 16px;
      margin: 0 auto 6px;

      ${plume.illustrations.Illustration} {
        margin-right: 8px;
      }
    }

    ${plume.styles.copy.M.light} {
      margin-bottom: 0;
    }
  }
`
